import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { UserService } from 'src/app/core/services/user.service';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import * as UserDetailsActions from './user.action';
import { mergeMap, map, catchError } from 'rxjs/operators';
import {
  IUserRootObject,
  IRecentCheckInRootObject,
  IActiveCheckInRootObject,
  IUserPermissionRootObject
} from '../../models/user';


@Injectable()

export class UserApiEffects {
  constructor(private actions$: Actions, private userService: UserService) { }
  GetUserDetails$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(UserDetailsActions.GetUserDetailsApiAction),
    mergeMap(action => this.userService.fetchUserDetails().pipe(
      map((response: IUserRootObject) => {
        return UserDetailsActions.SuccessGetUserDetailsApiAction({ userDetails: response });
      }),
      catchError(error => {
        this.userService.setError(error);
        return of(UserDetailsActions.ErrorPostUserDetailsApiAction(error));
      })
    ))
  ));

  PostUserDetails$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(UserDetailsActions.PostUserDetailsApiAction),
    mergeMap(action => this.userService.postUserData(action.userDetails).pipe(
      map((response: IUserRootObject) => {
        return UserDetailsActions.SuccessPostUserDetailsApiAction({ userDetails: response });
      }),
      catchError(error => {
        this.userService.setError(error);
        return of(UserDetailsActions.ErrorPostUserDetailsApiAction(error));
      })
    ))));

  HRApiDetails$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(UserDetailsActions.GetHRApiDetailsApiAction),
    mergeMap(action => this.userService.getHRApiDetails().pipe(
      map((response) => {
        return UserDetailsActions.SuccessGetHRApiDetailsApiAction();
      }),
      catchError(error => {
        return of(UserDetailsActions.ErrorGetHRApiDetailsApiAction());
      })
    ))));

  UserPermissionsMapping$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(UserDetailsActions.GetUserPermissionApiAction),
    mergeMap(action => this.userService.getUserPermissionMapping().pipe(
      map((response: IUserPermissionRootObject) => {
        return UserDetailsActions.SuccessGetUserPermissionApiAction({ permissions: response.payload });
      }),
      catchError(error => {
        return of(UserDetailsActions.ErrorGetUserPermissionApiAction(error));
      })
    ))));

  GetRecentTwoDetails$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(UserDetailsActions.GetUserRecentDetailsApiAction),
    mergeMap(action => this.userService.getRecentCheckinData().pipe(
      map((response: IRecentCheckInRootObject) => {
        return UserDetailsActions.SuccessGetUserRecentDetailsApiAction({ recentCheckIn: response?.payload });
      }),
    ))
  ));

  GetActiveCheckinDetails$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(UserDetailsActions.GetUserActiveCheckinDetailsApiAction),
    mergeMap(action => this.userService.getActiveCheckinData().pipe(
      map((response: IActiveCheckInRootObject) => {
        return UserDetailsActions.SuccessGetUserActiveCheckinDetailsApiAction({ activeCheckIn: response?.payload });
      }),
    ))
  ));

  handleError = (error) => {
    this.userService.setError(error);
  }
}
